import { postJson } from '../config/HttpClient'
import type { Artigo } from './Artigo'
import { numeroDaApi } from '@/utils/moeda'

export interface Categoria {
  id: number
  nome: string
}

export interface Cliente {
  id: number
  nome: string
  nomeNif: string
  nif: string
  endereco: string
  telemovel: string
}

export interface ContaPos {
  id_conta: number
  banco: string
  nome_conta: string
  numero_conta: string
  iban: string
  sigla: string
  padrao: number
}

export const NIF_CONSUMIDOR_FINAL = '999999999'

class ArtigosService {
  private contasCache: ContaPos[] | null = null

  async listarArtigos(idPosto: number, pagina: number): Promise<Artigo[]> {
    const artigos = await postJson<Artigo[] | null>(`/api-stock/pos/lista-artigos-by-empresa/${idPosto}/${pagina}`)
    return (artigos ?? []).map(artigo => ({
      ...artigo,
      preco: numeroDaApi(artigo.preco),
      taxa: numeroDaApi(artigo.taxa),
      stock: numeroDaApi(artigo.stock)
    }))
  }

  async listarCategorias(): Promise<Categoria[]> {
    return postJson<Categoria[]>('/api-stock/pos/lista-categorias-artigos-by-empresa')
  }

  async listarClientes(pagina: number): Promise<Cliente[]> {
    return postJson<Cliente[]>(`/api-stock/pos/lista-clientes-by-empresa/${pagina}`)
  }

  async obterClientePorNif(nif: string): Promise<Cliente | null> {
    return postJson<Cliente | null>(`/api-stock/pos/cliente-by-nif/${nif}`)
  }

  async listarContas(): Promise<ContaPos[]> {
    if (this.contasCache) return this.contasCache

    const resultado = await postJson<ContaPos[] | null>('/pos-dexa/lista-contas-payment')
    this.contasCache = resultado ?? []
    return this.contasCache
  }
}

export default new ArtigosService()
